import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import BlurModal from '../../../../../../src/components/common/blur-modal';
// import Button from '../../../../../../src/components/common/button';
import Button from '@dbk/ui-buttons';
import Text from '@dbk/ui-text';
import styles from './app-idle.styles';
class AppIdlePopup extends PureComponent {

  resetTime = (e) => {
    this.props.resetTime(e)
    this.props.inactive.setPopupVisibility(false);  //WMCE-32351
   }
  
 logoutFunction= (e) => {
  this.props.logoutFunction(e)   
  }

  logoutAtZero = () => {
    this.props.logoutAtZero()
  }
  componentDidMount(){
      if(document.querySelector('.ModalHeader span')){ // for logout popup heading focusable
      document.querySelector('.ModalHeader span').focus();
    }
  }
 
  render() {
    const { inactive, i18n: { messages } } = this.props;
      //WMCE-17601: Remain logged in popup going to negative timer
        // Changing the ccondition to logout even when timer goes negative
        if(this.props.inactive.countdown <= 0)
        {
          //console.log("GOING TO LOGOUT : " + this.props.inactive.countdown) 
             this.logoutAtZero();
        }

        return (
        
          <BlurModal
            visible={true}
            size="large"
            doneVisible={false}
            title={"Deutsche Wealth Online"}
            className={"model-window-login"}
            disableOutsideClick={true}
            onDone={() => this.props.inactive.setPopupVisibility(false)}
          >
            <div className="row margin-top-10">
              <div className="small-12">
                  <div>
                    <Text tabIndex={0} size="large" style={styles.popupTitle}>{messages['app.common.appIdle.remailLogged']}</Text>
                    <Text tabIndex={0} style={styles.popupBody}>{messages['app.common.appIdle.logoutMsg']} {inactive.countdown} {messages['app.common.appIdle.seconds']}</Text>

                    <div className="logout-confirm-btns margin-top-20">
                      <div className="logout-button" name="inactiveno">
                        <Button testID="no_button_logout_popup" id="no_button_logout_popup" size="medium" tertiary onClick={(e) => this.logoutFunction(e)}>
                          {messages['app.common.alert.no']}
                        </Button>
                      </div>
                      <div>
                        <Button testID="yes_button_logout_popup" id="yes_button_logout_popup" size="medium" onClick={(e) => this.resetTime(e)}>
                          {messages['app.common.alert.yes']}
                        </Button>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </BlurModal>

        )
    }
  }

export default createContainer({
  $queries: {
    logout: { $call: 'auth.logout' },
    rmLogout: { $call : 'rmAccess.logout'},
    i18n: {
      messages: true,
    },
    inactive: {
      countdown: true,
      startCountdownTimer: { $call: 'startCountdownTimer' },
      stopCountdownTimer: { $call: 'stopCountdownTimer' },
      setPopupVisibility: { $call: 'setPopupVisibility'},  //WMCE-32351
      autoLogoutEvent: true,
    },
}})(AppIdlePopup);
